import { nanoid } from 'nanoid';
// Original source from Dog API - Dog CEO -> modified and simplified
// For PostForm - dog breed select options

export const dogBreeds = [
  { id: nanoid(8), label: 'Affenpinscher' },
  { id: nanoid(8), label: 'Airedale' },
  { id: nanoid(8), label: 'Akita' },
  { id: nanoid(8), label: 'Appenzeller' },
  { id: nanoid(8), label: 'Australian Shepherd' },
  { id: nanoid(8), label: 'Basenji' },
  { id: nanoid(8), label: 'Beagle' },
  { id: nanoid(8), label: 'Bluetick' },
  { id: nanoid(8), label: 'Borzoi' },
  { id: nanoid(8), label: 'Bouvier' },
  { id: nanoid(8), label: 'Boxer' },
  { id: nanoid(8), label: 'Brabancon' },
  { id: nanoid(8), label: 'Bbriard' },
  { id: nanoid(8), label: 'Boston Bulldog' },
  { id: nanoid(8), label: 'English Bulldog' },
  { id: nanoid(8), label: 'French Bulldog' },
  { id: nanoid(8), label: 'Bullterrier' },
  { id: nanoid(8), label: 'Australian Cattledog' },
  { id: nanoid(8), label: 'Chihuahua' },
  { id: nanoid(8), label: 'Chow Chow' },
  { id: nanoid(8), label: 'Clumber' },
  { id: nanoid(8), label: 'Cockapoo' },
  { id: nanoid(8), label: 'Border Collie' },
  { id: nanoid(8), label: 'Coonhound' },
  { id: nanoid(8), label: 'Corgi' },
  { id: nanoid(8), label: 'Cotondetulear' },
  { id: nanoid(8), label: 'Dachshund' },
  { id: nanoid(8), label: 'Dalmatian' },
  { id: nanoid(8), label: 'Great Dane' },
  { id: nanoid(8), label: 'Scottish Deerhound' },
  { id: nanoid(8), label: 'Dingo' },
  { id: nanoid(8), label: 'Doberman' },
  { id: nanoid(8), label: 'Norwegian Elkhound' },
  { id: nanoid(8), label: 'Entlebucher' },
  { id: nanoid(8), label: 'Eskimo' },
  { id: nanoid(8), label: 'Lapphund Finnish' },
  { id: nanoid(8), label: 'Bichon Frise' },
  { id: nanoid(8), label: 'Germanshepherd' },
  { id: nanoid(8), label: 'Italian Greyhound' },
  { id: nanoid(8), label: 'Groenendael' },
  { id: nanoid(8), label: 'Havanese' },
  { id: nanoid(8), label: 'Afghan Hound' },
  { id: nanoid(8), label: 'Basset Hound' },
  { id: nanoid(8), label: 'Blood Hound' },
  { id: nanoid(8), label: 'English Hound' },
  { id: nanoid(8), label: 'Ibizan Hound' },
  { id: nanoid(8), label: 'Plott Hound' },
  { id: nanoid(8), label: 'Walker Hound' },
  { id: nanoid(8), label: 'Husky' },
  { id: nanoid(8), label: 'Keeshond' },
  { id: nanoid(8), label: 'Kelpie' },
  { id: nanoid(8), label: 'Komondor' },
  { id: nanoid(8), label: 'Kuvasz' },
  { id: nanoid(8), label: 'Labradoodle' },
  { id: nanoid(8), label: 'Labrador' },
  { id: nanoid(8), label: 'Leonberg' },
  { id: nanoid(8), label: 'Lhasa' },
  { id: nanoid(8), label: 'Malamute' },
  { id: nanoid(8), label: 'Malinois' },
  { id: nanoid(8), label: 'Maltese' },
  { id: nanoid(8), label: 'Bull Mastiff' },
  { id: nanoid(8), label: 'English Mastiff' },
  { id: nanoid(8), label: 'Tibetan Mastiff' },
  { id: nanoid(8), label: 'Mexicanhairless' },
  { id: nanoid(8), label: 'Mix' },
  { id: nanoid(8), label: 'Bernese Mountain' },
  { id: nanoid(8), label: 'Swiss Mountain' },
  { id: nanoid(8), label: 'Newfoundland' },
  { id: nanoid(8), label: 'Norwegian Buhund' },
  { id: nanoid(8), label: 'Otterhound' },
  { id: nanoid(8), label: 'Caucasian Ovcharka' },
  { id: nanoid(8), label: 'Papillon' },
  { id: nanoid(8), label: 'Pekinese' },
  { id: nanoid(8), label: 'Pembroke' },
  { id: nanoid(8), label: 'Miniature Pinscher' },
  { id: nanoid(8), label: 'Pitbull' },
  { id: nanoid(8), label: 'German Pointer' },
  { id: nanoid(8), label: 'Germanlonghair Pointer' },
  { id: nanoid(8), label: 'Pomeranian' },
  { id: nanoid(8), label: 'Miniature Poodle' },
  { id: nanoid(8), label: 'Standard Poodle' },
  { id: nanoid(8), label: 'Toy Poodle' },
  { id: nanoid(8), label: 'Pug' },
  { id: nanoid(8), label: 'Puggle' },
  { id: nanoid(8), label: 'Pyrenees' },
  { id: nanoid(8), label: 'Redbone' },
  { id: nanoid(8), label: 'Chesapeake Retriever' },
  { id: nanoid(8), label: 'Curly Retriever' },
  { id: nanoid(8), label: 'Flatcoated Retriever' },
  { id: nanoid(8), label: 'Golden Retriever' },
  { id: nanoid(8), label: 'Rhodesian Ridgeback' },
  { id: nanoid(8), label: 'Rottweiler' },
  { id: nanoid(8), label: 'Saluki' },
  { id: nanoid(8), label: 'Samoyed' },
  { id: nanoid(8), label: 'Schipperke' },
  { id: nanoid(8), label: 'Giant Schnauzer' },
  { id: nanoid(8), label: 'Miniature Schnauzer' },
  { id: nanoid(8), label: 'English Setter' },
  { id: nanoid(8), label: 'Gordon Setter' },
  { id: nanoid(8), label: 'Irish Setter' },
  { id: nanoid(8), label: 'English Sheepdog' },
  { id: nanoid(8), label: 'Shetland Sheepdog' },
  { id: nanoid(8), label: 'Shiba' },
  { id: nanoid(8), label: 'Shihtzu' },
  { id: nanoid(8), label: 'Blenheim Spaniel' },
  { id: nanoid(8), label: 'Brittany Spaniel' },
  { id: nanoid(8), label: 'Cocker Spaniel' },
  { id: nanoid(8), label: 'Irish Spaniel' },
  { id: nanoid(8), label: 'Japanese Spaniel' },
  { id: nanoid(8), label: 'Sussex Spaniel' },
  { id: nanoid(8), label: 'Welsh Spaniel' },
  { id: nanoid(8), label: 'English Springer' },
  { id: nanoid(8), label: 'Stbernard' },
  { id: nanoid(8), label: 'American Terrier' },
  { id: nanoid(8), label: 'Australian Terrier' },
  { id: nanoid(8), label: 'Bedlington Terrier' },
  { id: nanoid(8), label: 'Border Terrier' },
  { id: nanoid(8), label: 'Cairn Terrier' },
  { id: nanoid(8), label: 'Dandie Terrier' },
  { id: nanoid(8), label: 'Fox Terrier' },
  { id: nanoid(8), label: 'Irish Terrier' },
  { id: nanoid(8), label: 'Kerryblue Terrier' },
  { id: nanoid(8), label: 'Lakeland Terrier' },
  { id: nanoid(8), label: 'Norfolk Terrier' },
  { id: nanoid(8), label: 'Norwich Terrier' },
  { id: nanoid(8), label: 'Patterdale Terrier' },
  { id: nanoid(8), label: 'Russell Terrier' },
  { id: nanoid(8), label: 'Scottish Terrier' },
  { id: nanoid(8), label: 'Sealyham Terrier' },
  { id: nanoid(8), label: 'Silky Terrier' },
  { id: nanoid(8), label: 'Tibetan Terrier' },
  { id: nanoid(8), label: 'Toy Terrier' },
  { id: nanoid(8), label: 'Welsh Terrier' },
  { id: nanoid(8), label: 'Westhighland Terrier' },
  { id: nanoid(8), label: 'Wheaten Terrier' },
  { id: nanoid(8), label: 'Yorkshire Terrier' },
  { id: nanoid(8), label: 'Tervuren' },
  { id: nanoid(8), label: 'Vizsla' },
  { id: nanoid(8), label: 'Spanish Waterdog' },
  { id: nanoid(8), label: 'Weimaraner' },
  { id: nanoid(8), label: 'Whippet' },
  { id: nanoid(8), label: 'Irish Wolfhound' },
];

export default dogBreeds;
